module.exports = __webpack_public_path__ + "img/two-beads-logo.e0fdf7b8.png";